module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1038.1b840816.png";